/* unplugin-vue-components disabled */import script from "./personalAccountRenewal.vue?vue&type=script&setup=true&lang=js"
export * from "./personalAccountRenewal.vue?vue&type=script&setup=true&lang=js"

import "./personalAccountRenewal.vue?vue&type=style&index=0&id=2e3ba658&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/frontend_prod_master@2/project/wfzx-platform-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e3ba658"]])

export default __exports__